export default __webpack_public_path__ + "static/media/whitelabel.763ee075.svg";